class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, undefined).then(() => {
      });
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.#onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.main-cart',
        copyClasses: true
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  async swapVariant(line, newVariantId) {
    const quantityInput = document.querySelector(`#Quantity-${line}`);
    if (!quantityInput) return;
    return await this.updateQuantity(line, 0, undefined, false).then(async () => {
      const config = fetchConfig();
      config.body = JSON.stringify({
        items: [{
          id: newVariantId,
          quantity: quantityInput.value,
        }],
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
      return await this.#addToCart(config, newVariantId);
    });
  }

  async updateQuantity(line, quantity, name, shouldUpdate = true) {
    this.#enableLoading(line);
    const requestBody = {
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    };

    const body = JSON.stringify(requestBody);

    return await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.#updateLiveRegions(line, parsedState.errors);
          return;
        }

        shouldUpdate && this.#toggleCartEmptyState(parsedState.item_count === 0);
        shouldUpdate && this.#updateSections(parsedState);
        this.#updateLiveRegions(line, this.#getErrorMessage(line, parsedState, quantityElement, items));
        this.#setFocus(parsedState, line, name);
        shouldUpdate && publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch((e) => {
        console.error(e);
        this.#displayError();
      })
      .finally(() => {
        this.#disableLoading(line);
      });
  }

  async #addToCart(config, newVariantId) {
    return await fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            newVariantId,
            errors: response.errors || response.description,
            message: response.message,
          });

        } else {
          this.#toggleCartEmptyState(response.items.length === 0);
          this.#updateSections(response);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  #onChange(event) {
    if (!event.target.classList.contains('quantity__input')) {
      return;
    }
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
    ).then(() => {
    });
  }

  #toggleCartEmptyState(isEmpty) {
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    this.classList.toggle('is-empty', isEmpty);
    if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', isEmpty);
  }

  #updateSections(parsedState) {
    const getSection = (html, selector) => {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
    };

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      const newSection = getSection(parsedState.sections[section.section], section.selector);
      if (section.copyClasses) {
        elementToReplace.className = newSection.className;
      }
      elementToReplace.innerHTML = newSection.innerHTML;
    });
  }

  #getErrorMessage(line, parsedState, quantityElement, items) {
    const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;

    if (!(items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value))) {
      return '';
    }

    if (typeof updatedValue === 'undefined') {
      return window.cartStrings.error;
    }

    return window.cartStrings.quantityError.replace('[quantity]', updatedValue);
  }

  #setFocus(parsedState, line, name) {
    const lineItem = document.getElementById(`CartItem-${line}`);
    const cartDrawerWrapper = document.querySelector('cart-drawer');

    if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      const innerEmpty = cartDrawerWrapper.querySelector('.drawer__inner-empty');
      innerEmpty && trapFocus(innerEmpty, cartDrawerWrapper.querySelector('a'));
    } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
    }
  }

  #displayError() {
    this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
    const errorContainer = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (errorContainer) errorContainer.textContent = window.cartStrings.error;
  }

  #updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  #enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  #disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}
